/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentPatchModel } from '../../models/agent-patch-model';
import { AgentResponse } from '../../models/agent-response';

export interface PatchApiAgentV1Id$Plain$Params {

/**
 * The unique identifier of the agent to update.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The patch model containing updated agent fields.
     */
    body?: AgentPatchModel
}

export function patchApiAgentV1Id$Plain(http: HttpClient, rootUrl: string, params: PatchApiAgentV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResponse>> {
  const rb = new RequestBuilder(rootUrl, patchApiAgentV1Id$Plain.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentResponse>;
    })
  );
}

patchApiAgentV1Id$Plain.PATH = '/private/v1/agents/{id}';
